import {
  ANODE,
  CATHODE,
  LITHIUM_ION_BATTERIES,
  PRECURSOR_ASSESSMENT,
  SUBSCRIPTION_FORECASTS_LITHIUM_ION_BATTERIES,
  SUBSCRIPTION_MARKET_ASSESSMENTS_PRECURSOR_ASSESSMENT,
  SUBSCRIPTION_PRICE_ASSESSMENTS_ANODE,
  SUBSCRIPTION_PRICE_ASSESSMENTS_CATHODE,
} from '~/constants/services/constants'

export const CD_STATUS = [
  { selected: true, label: 'Operational', slug: 'operational' },
  { selected: true, label: 'Construction', slug: 'construction' },
  { selected: true, label: 'Not Yet Assessed', slug: 'not_yet_assessed' },
]

export const CD_UNAUTHORIZED_DESCRIPTIONS = {
  title: null,
  texts: [
    'Our Price Assessments draw on Benchmark’s proprietary databases, tracking every global production facility, capacity expansions, technology developments and industry partnerships to provide clarity to the complex lithium ion battery landscape.',
  ],
}

export const CD_COLORS = ['#fdbd00', '#2e459a', '#3856c1', '#a6b9ff']
export const CD_TEXT_CLASS_DEFAULT = [
  'text-grey-900',
  'text-grey-900',
  'text-grey-900',
  'text-grey-900',
]
export const CD_BG_CLASS_DEFAULT = [
  'bg-grey-900',
  'bg-grey-900',
  'bg-grey-900',
  'bg-grey-900',
]

/*-------------------------------------
  Methodology Files Info
-------------------------------------*/
export const METHODOLOGY_FILE_INFO = {
  [ANODE.slug]: {
    category: 'methodology-price-assessments',
    file_name: 'Benchmark-Anode-Price-Assessment-Methodology.pdf',
    EnvKey: 'anodePriceAssessmentsMethodologyId',
  },
  [CATHODE.slug]: {
    category: 'methodology-price-assessments',
    file_name: 'Benchmark-Cathode-Price-Assessment-Methodology.pdf',
    EnvKey: 'cathodePriceAssessmentsMethodologyId',
  },
  [PRECURSOR_ASSESSMENT.slug]: {
    category: 'public-documents',
    file_name: 'Benchmark-Precursor-Market-Assessment-Methodology.pdf',
    EnvKey: 'precursorMarketAssessmentsMethodologyId',
  },
  [LITHIUM_ION_BATTERIES.alternativeSlug]: {
    category: 'methodology-market-assessments',
    file_name: 'Benchmark-Gigafactory-Assessment-Methodology.pdf',
    EnvKey: 'gigafactoriesPriceAssessmentsMethodologyId',
  },
} as const

/*-------------------------------------
  Subscriptions
-------------------------------------*/
export const CAPACITY_DATABASE_SUBSCRIPTIONS = {
  [ANODE.slug]: SUBSCRIPTION_PRICE_ASSESSMENTS_ANODE,

  [CATHODE.slug]: SUBSCRIPTION_PRICE_ASSESSMENTS_CATHODE,

  [PRECURSOR_ASSESSMENT.slug]:
    SUBSCRIPTION_MARKET_ASSESSMENTS_PRECURSOR_ASSESSMENT,

  [LITHIUM_ION_BATTERIES.slug]: SUBSCRIPTION_FORECASTS_LITHIUM_ION_BATTERIES,
} as const
